import { createContext } from "react"
import { AppCompaniesChoices } from "src/types"

export const SessionContext = createContext<{
    currentRound: number
    setNextRound: () => void
    rounds: AppCompaniesChoices[],
    prompts: number[],
    currentCompany: AppCompaniesChoices | null,
    recalculate: () => void
}>({
    currentRound: 0,
    setNextRound: () => {},
    rounds: [],
    prompts: [],
    currentCompany: null,
    recalculate: () => {}
})